import { render, staticRenderFns } from "./ModalImportedActivity.vue?vue&type=template&id=2832003c&"
import script from "./ModalImportedActivity.vue?vue&type=script&lang=ts&"
export * from "./ModalImportedActivity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports